import store from '@/store';

export default class ManualWhatsAppRequestEvent {
  constructor(message) {
    const errors = {
      EVALUATION: 'O cliente está em avaliação!',
      ALREADY_IN_INBOX:
        'Já existe um atendimento de WhatsApp fidelizado com este mesmo telefone e número de rota!',
      ALREADY_PREFERENTIAL:
        'Já existe um atendimento de WhatsApp de carteira vinculado à outro agente, com este mesmo telefone!',
      ROUTE_NUMBER:
        'Não existe nenhuma rota de WhatsApp vinculada para esta campanha!',
      ALREADY_IN_ATTENDANCE:
        'Já existe um atendimento de WhatsApp com este mesmo telefone!',
      CLIENT_ON_HOLD: 'Este cliente está em fila de espera',
    };

    if (!message.allowed)
      store.dispatch(
        'showSnackbar',
        {
          text: `${
            errors[message.reason]
              ? errors[message.reason]
              : 'Erro ao entrar em atendimento!'
          }`,
          type: 'error',
        },
        { root: true },
      );
  }
}
